import { BaseModel } from "./hateoas/base-model";

export class ParametersTypeModel extends BaseModel {
  name?: number;
  fieldName?: string;
  operationType?: string;
  ruleModelContains?: string;
}
